import { render, staticRenderFns } from "./GroupDealPageWidget.vue?vue&type=template&id=267cf3ca&scoped=true"
import script from "./GroupDealPageWidget.vue?vue&type=script&lang=js"
export * from "./GroupDealPageWidget.vue?vue&type=script&lang=js"
import style0 from "./GroupDealPageWidget.vue?vue&type=style&index=0&id=267cf3ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267cf3ca",
  null
  
)

export default component.exports